import { Component, OnInit, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding } from '@angular/core';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'vg-snipe',
    encapsulation: ViewEncapsulation.None,
    template: `<div class="vg-snipe" [ngClass]="" [mediatag]="data" *ngIf="data" >
               </div>`,
    styles: [`        
        vg-snipe {
            z-index: 110;          
        }       
        vg-snipe.is-fullscreen, vg-snipe.is-native-fullscreen, vg-snipe.is-playing {
            display: none;
        }
        vg-snipe .vg-snipe {
            pointer-events: none;
            position: absolute !important;
            top:0; left:0;
            width:100%;
            height:100%;
        }
    ` ]
})
export class VgSnipe implements OnInit, OnDestroy {
    @Input() vgFor: string;
    @Input() data: any; //{state,text}

    private target: any;
    private subscriptions: Array<any> = [];

    @HostBinding('class.is-playing') isPlaying: boolean;
    @HostBinding('class.is-fullscreen') isFullscreen: boolean = false;

    constructor(public API: VgAPI, public fsAPI: VgFullscreenAPI, private controlsHidden: VgControlsHidden) {
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);
        this.subscriptions.push(this.fsAPI.onChangeFullscreen.subscribe(this.onChangeFullscreen.bind(this)));
        this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));
    }

    onChangeFullscreen(fsState) {
        this.isFullscreen = fsState;
    };

    onHideControls(hidden) {
        this.isPlaying = hidden;
    };

    ngOnDestroy() {     
        if(this.subscriptions)
        {
            this.subscriptions.forEach(s => s.unsubscribe());
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-snipe.component.ts